import * as React from "react"
import { useState } from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/products/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import Modal from "./Model"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import { useAppSelector } from "@/lib/hooks"
import { isAdminPortal } from "@/utilities/domain"
import {
  ReportBranchFilter,
  ReportBranchProvider,
  useReportBranch,
  withBranchColumn,
} from "@/components/Reports/ReportBranchFilter"

const adminColumns = withBranchColumn(columns)

export default function ProductList() {
  return (
    <>
      <div className="breadcrumb-card">
        <h5>Product</h5>
      </div>

      <CrudProvider>
        <ProductTable />
      </CrudProvider>
    </>
  )
}

function ProductTable() {
  const { openDialog } = useCrudContext()
  // A cashier can read products for sales (lookup) without managing the catalog
  const permissions = new Set(
    useAppSelector((state) => state.auth.user?.permissions ?? [])
  )
  const canImport = permissions.has("operations-imports-create")

  if (isAdminPortal()) {
    return (
      <ReportBranchProvider>
        <AdminProductTable />
      </ReportBranchProvider>
    )
  }

  return (
    <>
      <CustomTable
        label="Product"
        columns={columns}
        apiPath="product"
        addBtn={permissions.has("inventory-products-create")}
        showEdit={permissions.has("inventory-products-update")}
        showDelete={permissions.has("inventory-products-delete")}
        showImport={canImport && permissions.has("inventory-products-create")}
        onExport={permissions.has("operations-exports-create")}
        onEditImport={canImport && permissions.has("inventory-products-update")}
      />

      {openDialog ? <Modal /> : null}
    </>
  )
}

// Company administrators can browse and export the catalog, for every branch
// or a selected one; it is still managed from each branch portal.
function AdminProductTable() {
  const { branchId } = useReportBranch()
  const branchFilter = React.useMemo(
    () => ({ branch_id: branchId }),
    [branchId]
  )

  return (
    <CustomTable
      label="Product"
      columns={adminColumns}
      apiPath="product"
      addBtn={false}
      showEdit={false}
      showDelete={false}
      onExport
      hardcodedFilters={branchFilter}
      exportParams={branchFilter}
      renderFilters={() => <ReportBranchFilter sx={{ mb: 0 }} />}
    />
  )
}
